import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { BodyContext } from '~/context/BodyContext.js'

export const Footer = props => {
    const [CT] = useContext(BodyContext);
    return (
        <footer className="FOOTER">
            <div className="basic">
                <div className="socials">
                    <a className="social"  href="https://twitter.com/etcpunks">
                        <div className="IC">
                            <img src={require('~/assets/images/interface/social-twitter.png').default} alt="" />
                        </div>
                    </a>
                    <a className="social"  href="https://t.me/etcpunks">
                        <div className="IC">
                            <img src={require('~/assets/images/interface/social-telegram.png').default} alt="" />
                        </div>
                    </a>
                    <a className="social"  href="https://medium.com/@etcpunks">
                        <div className="IC">
                            <img src={require('~/assets/images/interface/social-medium.png').default} alt="" />
                        </div>
                    </a>
                    <a className="social"  href="https://discord.gg/cdDUgGBWmF">
                        <div className="IC">
                            <img src={require('~/assets/images/interface/social-discord.png').default} alt="" />
                        </div>
                    </a>
                </div>
                <a className="power"  href="https://ethereumclassic.org/">
                    <div className="logo">
                        <div className="IC">
                            <img src={require('~/assets/images/interface/service-etc.png').default} alt="" />
                        </div>
                    </div>
                    <div className="text">
                        <p>
                            Powered by Ethereum Classic
                        </p>
                    </div>
                </a>
            </div>
            <div className="extra">
                <div className="links">
                    <a className="link"  href="https://blockscout.com/etc/mainnet/address/0x273Bc20299976Fb0BA58A991cb60a27E8Cdc8685">
                        <span>
                            Contract
                        </span>
                    </a>
                    {/*<a className="link"  href="https://opensea.io/collection/0x273Bc20299976Fb0BA58A991cb60a27E8Cdc8685punk">*/}
                    {/*    <span>*/}
                    {/*        Opensea*/}
                    {/*    </span>*/}
                    {/*</a>*/}
                    {/*<a className="link"  href="https://lootex.io/stores/ETCPunks">*/}
                    {/*    <span>*/}
                    {/*        Lootex*/}
                    {/*    </span>*/}
                    {/*</a>*/}
                    {/*<a className="link"  href="https://treasureland.market/collection/0x320f537da591da33dd1a04dcb062434e3d176d3e">*/}
                    {/*    <span>*/}
                    {/*        Treasureland*/}
                    {/*    </span>*/}
                    {/*</a>*/}
                    {/*<a className="link"  href={CT.statics.docs.white_paper}>*/}
                    {/*    <span>*/}
                    {/*        White Paper*/}
                    {/*    </span>*/}
                    {/*</a>*/}
                </div>
            </div>
        </footer>
    )
}
